(function () {
  var variants = window.eHS.product.variants;

  var flavorSizes = {};

  variants.forEach(function (variant) {
    var flavor = variant.option1;
    var size = variant.option2;

    if (!flavor || !size) return;

    if (!flavorSizes[flavor]) {
      flavorSizes[flavor] = [];
    }

    if (!flavorSizes[flavor].includes(size)) {
      flavorSizes[flavor].push(size);
    }
  });

  function updateSizes() {
    var flavorButton = document.querySelector(
      '[data-option="flavor"] [data-product-option-selector].active'
    );

    if (!flavorButton) {
      console.log('No active flavor found');
      return;
    }

    var flavor = flavorButton.dataset.productOptionSelector;
    var validSizes = flavorSizes[flavor] || [];

    console.log('Flavor:', flavor);
    console.log('Valid sizes:', validSizes);

    document
      .querySelectorAll(
        '[data-option="size"] [data-product-option-selector]'
      )
      .forEach(function (sizeButton) {
        var size = sizeButton.dataset.productOptionSelector;
        var exists = validSizes.includes(size);

        sizeButton.style.display = exists ? '' : 'none';

        console.log(
          exists ? 'SHOW:' : 'HIDE:',
          size
        );
      });
  }

  updateSizes();

  document.addEventListener('click', function (event) {
    var flavorButton = event.target.closest(
      '[data-option="flavor"] [data-product-option-selector]'
    );

    if (!flavorButton) return;

    setTimeout(updateSizes, 50);
  });

  window.skratchVariantFix = {
    update: updateSizes
  };

  console.log('✅ Skratch variant visibility test installed');
})();